import React from 'react';
import { IArticle } from '../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const poryadok_razmeshenia_markera_v_reklame: IArticle = {
  title: 'Порядок размещения маркера (erid:xxxxx) в рекламе с примерами',
  image: '/assets/img/blog/poryadok_razmeshenia_markera_v_reklame.jpeg',
  prewievImage:
    '/assets/img/blog/poryadok_razmeshenia_markera_v_reklame-prewiev.jpeg',
  content: [
    {
      text: [
        'Согласно Федеральному закону от 02.07.2021 N 347-ФЗ (пункт 18.1) все рекламные материалы, размещаемые в сети интернет на территории РФ, должны быть промаркированы и содержать официальные атрибуты маркировки.',
      ],
    },
    {
      subTitle: 'Понятие маркировка рекламы включает:',
      text: [
        <ul>
          <li>
            Добавление ко всем рекламным публикациям в интернете пометки
            «реклама», информации о рекламодателе (название организации) и/или
            ссылки на веб-ресурс с информацией о рекламодателе.
          </li>
          <li>
            Наличие в каждой рекламной публикации специального идентификатора
            (рекламного маркера/токена erid: xxxx).
          </li>
          <li>
            Предоставление сведений о рекламе в ЕРИР, посредством передачи
            данных о рекламе через ОРД.
          </li>
        </ul>,
        'Перед публикацией любого рекламного материала в интернете его следует зарегистрировать в ОРД, передать сведения о рекламодателе и данные о креативе. Автоматически при регистрации данных о составе РК, креативу присваивается уникальный идентификатор (erid).',
        <>
          Подробно о процессе и понятии «маркировка» мы рассказали в материале{' '}
          <a href="/blog/markirovka_reklami_v_internete">
            «Маркировка рекламы в интернете: обзор ключевых моментов»
          </a>
          .
        </>,
      ],
    },
    {
      subTitle: 'Формы креативов и порядок размещения маркера (erid)',
      text: [
        'В данном материале мы осветим основные моменты и правила по размещению рекламного идентификатора (erid) для следующих видов рекламных публикаций:',
        <ul>
          <li>
            Текстовые блоки (контекстная реклама, рекламные блоки в блогах);
          </li>
          <li>Текстовые блоки с видео или аудио;</li>
          <li>Текстовые блоки с аудио и видео;</li>
          <li>Текстово-графические блоки;</li>
          <li>Текстово-графические блоки с видео или аудио;</li>
          <li>Текстово-графические блоки с аудио и видео;</li>
          <li>Баннеры;</li>
          <li>HTML5-баннеры;</li>
          <li>Видеоматериалы, включая Stories, кружки в Телеграм;</li>
          <li>Видео- аудио- трансляция в прямом эфире;</li>
          <li>Аудиозаписи / подкасты;</li>
        </ul>,
      ],
    },
    {
      subTitle: 'Текстовые блоки:',
      text: [
        'Маркер (erid: xxxxx) размещается в начале или в конце текста. Указывается наименование организации и ИНН. Пометка «Реклама». Если в тексте присутствует ссылка, маркер встраивается в ссылку, например:',
        <i>https://www.site.ru/?erid=xxxxxx</i>,
        'Если ссылка уже содержит какие-либо GET-параметры, то erid добавляется либо сразу после знака «?», либо через «&» в списке GET-параметров, например:',
        <>
          <i>
            hhttps://www.site.ru/?erid=xxxxxx&utm_source&utm_medium&utm_campaign&utm_content
          </i>
          <br />
          <i>
            https://www.site.ru/?utm_source&utm_medium&erid=xxxxxxx&utm_campaign&utm_content
          </i>
          <br />
          <i>
            https://www.site.ru/?utm_source&utm_medium&utm_campaign&utm_content&erid=xxxxxxx
          </i>
          <br />
        </>,
        <i>
          Важно отметить, что согласно приказу №191 от 30.11.22 (п.12) если в
          рекламном материале имеется ссылка, которая ведет на интернет-ресурс
          рекламодателя, то erid в приоритетном порядке должен быть зашит именно
          в ссылку.
        </i>,
        'Вместо ИНН и реквизитов рекламодателя разрешается размещать ссылку на сайт, например: Реклама. ООО «Весна», vesna.ru, при условии, что на данном сайте есть страница с реквизитами рекламодателя.',
        'Важно прописывать erid в тексте и на изображениях именно в указанном формате (erid: xxxxxxx). Если при написании будет допущена ошибка, Роскомнадзор может посчитать это нарушением.',
      ],
    },
    {
      subTitle: 'Текстовые блоки с аудио и видео:',
      text: [
        'Маркер (erid: xxxxx) может размещаться в начале или в конце текста. В конце текста указывается наименование организации и ИНН. Пометка «Реклама». Если в объявлении присутствует ссылка, erid размещается по правилам размещения маркера в ссылках.',
      ],
    },
    {
      subTitle: 'Текстово-графические блоки:',
      text: [
        'Маркер (erid: xxxxx) размещается в начале или в конце текста. В конце текста, либо поверх изображения указывается наименование организации и ИНН. Пометка «Реклама». Если в объявлении присутствует ссылка, erid размещается по правилам размещения маркера в ссылках.',
      ],
    },
    {
      subTitle: 'Текстово-графические блоки с аудио и видео:',
      text: [
        'Маркер (erid: xxxxx) может размещаться в начале или в конце текста, а также поверх видеоизображения. Указывается наименование организации и ИНН. Пометка «Реклама». Если в объявлении присутствует кликовая ссылка, erid размещается по правилам размещения маркера в ссылках.',
      ],
    },
    {
      subTitle: 'Баннеры / HTML5-баннеры:',
      text: [
        'Пометка «Реклама» размещается поверх изображения. Наименование организации и ИНН могут размещаться поверх баннера или в меню AdChoice. Маркер (erid: xxxxx) для некликабельных баннеров наносится поверх изображения, а для кликабельных встраивается в ссылку по правилам размещения маркера в ссылках.',
      ],
    },
    {
      subTitle: 'Видеоматериалы, включая Stories:',
      text: [
        'Пометка «Реклама» размещается поверх видео. Наименование организации, ИНН и маркер (erid: xxxxx) могут размещаться поверх видео или в меню AdChoice.',
      ],
    },
    {
      subTitle: 'Кружки в Телеграм:',
      text: [
        'Пометка «Реклама», наименование организации, ИНН, ссылка на сайт и маркер (erid: xxxxx) размещаются в следующем посте после «кружка».',
      ],
    },
    {
      subTitle: 'Видео-подкасты и видео-трансляция в прямом эфире:',
      text: [
        'Пометка «Реклама», наименование организации, ИНН, ссылка на сайт и маркер (erid: xxxxx) размещаются в описании к видео, а также текстом поверх видео в начале или в конце видео-подкаста или видео-трансляции.',
      ],
    },
    {
      subTitle: 'Аудио-подкасты и аудио-трансляции в прямом эфире:',
      text: [
        'Текст «Реклама» и наименование организации проговариваются голосов в эфире. Маркер (erid: xxxxx) размещается в описании к аудио.',
      ],
    },
    {
      subTitle: 'Маркировка рекламы, отчётность и ответственность',
      text: [
        'Важно своевременно подавать отчётность о рекламе в ЕРИР посредством регистрации данных в ОРД. За несоблюдение Закона и правил маркировки, к юридическим и физическим лицам могут быть применены меры административной ответственности в виде штрафов.',
        'Контроль за наличием пометки "Реклама" в рекламных публикациях и данных о компании рекламодателе (название организации) осуществляет ФАС, отслеживанием маркеров / токенов (erid) и отчетностью в публикациях занимается Роскомнадзор.',
        <>
          Подробнее в нашем материале{' '}
          <a href="/blog/otvetstvennost_za_shtrafi">
            «Ответственность и штрафы за отсутствие маркировки рекламы в
            интернете»
          </a>
          .
        </>,
        'В данном материале мы перечислили основные условия и правила размещения маркера erid в рекламных публикациях. Но если у вас остались вы всегда можете обратиться в службу клиентской поддержки ОРД от SberAds и наши менеджеры постараются помочь вам с решением вопроса.',
      ],
    },
  ],
};

export default poryadok_razmeshenia_markera_v_reklame;
